import {useCallback, useEffect, useRef} from 'react';

export function useDisableWindowScroll() {
  const windowScrollYRef = useRef(0);
  const windowScrollDisabled = useRef(false);

  const disableWindowScroll = useCallback(() => {
    windowScrollYRef.current = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${windowScrollYRef.current}px`;
    const htmlTag = document.getElementsByTagName('html')[0];
    // ios에서는 브라우저메뉴 숨김 상태에서 body에 fixed를 주게 되면 높이를 100%를 줘도 정상적으로 영역을 모두 채우지 못하는 이슈가 있습니다.
    // 그래서 100dvh와 100%중 더 높은 수치를 사용해 html과 body 화면을 채우도록 합니다.
    // 단, 스크롤이 생기지 않는 상황이라면 어차피 브라우저메뉴를 숨길 수 없기 때문에 스크롤이 생기는 상황에만 적용합니다.
    if (htmlTag && document.body.scrollHeight > window.innerHeight) {
      htmlTag.style.height = 'max(100dvh, 100%)';
    }
    windowScrollDisabled.current = true;
  }, []);

  const enableWindowScroll = useCallback(() => {
    // 의도적으로 scroll disabled해둔 상태가 아니라면 enable을 동작시키지 않습니다. 어찌되었던 스크롤 이동하는 코드가 있고, 오동작할 우려가 있기 때문입니다.
    if (!windowScrollDisabled.current) {
      return;
    }
    document.body.style.position = 'static';
    document.body.style.top = 'auto';
    const htmlTag = document.getElementsByTagName('html')[0];
    if (htmlTag) {
      htmlTag.style.height = '';
    }
    window.scrollTo({
      top: windowScrollYRef.current,
    });
    windowScrollDisabled.current = false;
  }, []);

  useEffect(() => {
    return () => {
      // 혹시 모르니 unmount시점에 스크롤을 풀어줍니다.
      enableWindowScroll();
    };
  }, [enableWindowScroll]);

  return {disableWindowScroll, enableWindowScroll};
}
